import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-agreements',
  templateUrl: './agreements.component.html',
  styleUrls: ['./agreements.component.css']
})
export class AgreementsComponent implements OnInit {
  @Input() agreements: any[] = [];
  filteredAgreements: any[] = [];
  showAll: boolean = false;

  constructor() { }

  ngOnInit(): void {
    this.filteredAgreements = this.agreements.filter(agreement => !agreement.agre_id_ || !agreement.agre_id_.includes('benefit'));
  }

  handleButtonClick(){
    
  }
}
